/**
 * LiquidityTrackingPrint — impression « Suivi des liquidités » (onglet Synthèse
 * du hub Liquidités). Réutilise le COMPOSANT RÉEL de l'écran
 * (FinancialsWorkingCapitalTab, section='synthesis') : graphique 12 mois roulants
 * + tuiles trésorerie/BFRE et rotations (DSO/DIO/DPO). Unité = hub Liquidités.
 */
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import FinancialsWorkingCapitalTab from '../FinancialsWorkingCapitalTab';
import { usePersistentValue } from '../../hooks/usePersistentState';
import { p } from '../../i18n/useP';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

export default function LiquidityTrackingPrint({ activeTenant, year, editedAt, onDataReady }) {
  const { t } = useTranslation();
  const tenantId = activeTenant?.id;
  const [unit] = usePersistentValue(`liq_unit_${tenantId}`, 'chf');
  const done = useRef(false);
  const ready = () => { if (!done.current) { done.current = true; if (onDataReady) onDataReady('liquidity-tracking'); } };

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint">
      <PrintReportHeader category={p('Rapport financier')} title={t('phrases:p_3c1376b0be')} year={year} unit={unit} tenant={activeTenant} editedAt={editedAt} />
      <FinancialsWorkingCapitalTab activeTenant={activeTenant} year={year} section="synthesis" unit={unit} onReady={ready} />
    </section>
  );
}
